module.exports = __webpack_public_path__ + "static/toast-action-do-bf16af9554de2256335b5cdfeedb5169.png";